import { Modal } from '@mui/material';
import ReactPlayer from 'react-player';
import CloseIcon from '@mui/icons-material/Close';

const playerCommons = {
  controls: true,
  width: '100%',
  height: '100%',
  playing: true,
};

export default function VideoModal({
  open,
  onClose,
  url,
}: {
  open: boolean;
  onClose: () => void;
  url: string;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          width: '80%',
          height: '80%',
          position: 'relative',
          left: '10%',
          top: '10%',
        }}
      >
        <div
          style={{
            position: 'absolute',
            color: 'white',
            textAlign: 'right',
            width: '100%',
          }}
        >
          <CloseIcon
            onClick={onClose}
            style={{
              marginRight: '10px',
              marginTop: '10px',
              cursor: 'pointer',
            }}
          />
        </div>
        <ReactPlayer url={url} {...playerCommons} />
      </div>
    </Modal>
  );
}
